export const capitalize = (string) => {
  const array = string.split(' ');
  return array.map((x) => x.charAt(0).toUpperCase() + x.slice(1).toLowerCase()).join(' ');
};

export const splitFullName = (fullName) => {
  const parts = fullName.trim().split(' ');
  const firstName = parts.shift();
  const lastName = parts.join(' ');
  return { firstName, lastName };
}
